var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74159 13.125C5.50826 13.125 5.29159 13 5.18326 12.7834C5.02492 12.475 5.14992 12.1 5.46659 11.9417C6.19159 11.5834 6.80826 11.0334 7.24992 10.3667C7.39992 10.1417 7.39992 9.85837 7.24992 9.63337C6.79992 8.96671 6.18326 8.41671 5.46659 8.05837C5.14992 7.90837 5.02492 7.53337 5.18326 7.21671C5.33326 6.90837 5.70826 6.78337 6.01659 6.94171C6.93326 7.40004 7.71659 8.09171 8.28326 8.94171C8.70826 9.58337 8.70826 10.4167 8.28326 11.0584C7.71659 11.9084 6.93326 12.6 6.01659 13.0584C5.93326 13.1 5.83326 13.125 5.74159 13.125Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 13.125H10.8333C10.4916 13.125 10.2083 12.8417 10.2083 12.5C10.2083 12.1583 10.4916 11.875 10.8333 11.875H14.1666C14.5083 11.875 14.7916 12.1583 14.7916 12.5C14.7916 12.8417 14.5083 13.125 14.1666 13.125Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.9584H7.50002C2.97502 18.9584 1.04169 17.025 1.04169 12.5V7.50002C1.04169 2.97502 2.97502 1.04169 7.50002 1.04169H12.5C17.025 1.04169 18.9584 2.97502 18.9584 7.50002V12.5C18.9584 17.025 17.025 18.9584 12.5 18.9584ZM7.50002 2.29169C3.65835 2.29169 2.29169 3.65835 2.29169 7.50002V12.5C2.29169 16.3417 3.65835 17.7084 7.50002 17.7084H12.5C16.3417 17.7084 17.7084 16.3417 17.7084 12.5V7.50002C17.7084 3.65835 16.3417 2.29169 12.5 2.29169H7.50002Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/code-icon.5511c9858532d948acb7e6469d52dfc0.svg";
export { ForwardRef as ReactComponent };